import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DateUtility} from '../../../core/utils/date-utility';

const customValueProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BirthDayCalendarComponent),
  multi: true,
};

@Component({
  selector: 'app-birth-day-calendar',
  templateUrl: './birth-day-calendar.component.html',
  styleUrls: ['./birth-day-calendar.component.scss'],
  providers: [customValueProvider],
})
export class BirthDayCalendarComponent implements ControlValueAccessor {
  @Input() selectedDate: number = null;
  @Input() maxDate: Date = new Date();
  @Input() disabled = false;

  @Output() valueSelect: EventEmitter<string> = new EventEmitter<string>();

  dateControl: FormControl;

  public placeholderLabel = 'MM/DD/YYYY';
  private date: Date | string;

  constructor(private fb: FormBuilder, private dateUtil: DateUtility) {}

  ngOnInit() {
    this.date = this.selectedDate ? this.dateUtil.formatDate(new Date(this.selectedDate)) : '';
    this.valueSelect.emit(this.date);

    this.dateControl = this.fb.control(this.date, Validators.required);
    this.dateValueChanged();
  }

  private dateValueChanged() {
    this.dateControl.valueChanges.subscribe((date) => {
      this.date = date ? this.dateUtil.formatDate(date) : '';
      this.propagateChange(this.date);
      this.valueSelect.emit(this.date);
    });
  }

  writeValue(value) {
    this.date = value ? new Date(value) : '';
    this.dateControl.setValue(this.date);
    this.propagateChange(this.date);
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn) {}

  private propagateChange = (_: any) => {};

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
